import { configureStore } from '@reduxjs/toolkit';

import conferenceDetailsReducer from './features/conference-details/conferenceSlice';
import confRegistrationReducer from './features/conference-payment/confRegistrationSlice';
import registrationTypeReducer from './features/conference-registration-type-list/conferenceRegistrationTypleListSlice';

const store = configureStore({
  reducer: {
    conferenceDetails: conferenceDetailsReducer,
    registrationType: registrationTypeReducer,
    confRegistration: confRegistrationReducer,
  },
});

export default store;
